import React from "react"
import { Col, Row } from "react-bootstrap"
import TypographyImage1 from "../../images/bakers-market/typography-1.png"
import TypographyImage2 from "../../images/bakers-market/typography-2.png"

const Typography = () => {
  return (
    <div>
      <Row>
        <Col className="py-5">
          <div className="title">Typography & Colors</div>
          <div className="d-flex justify-content-center align-items-center flex-column h-100 py-sm-5">
            <img
              src={TypographyImage1}
              alt="bakers-market typography-1"
              width="50%"
            ></img>
          </div>
        </Col>
        <Col xl={4} lg={4} sm={12}>
          <img
            src={TypographyImage2}
            className="w-100"
            alt="bakers-market typography-2"
          ></img>
        </Col>
      </Row>
    </div>
  );
}

export default Typography
